// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    headingBlack: "Ready to outpace everyone with the ",
    headingGradient: "best AI work platform?",
    mainButtonText: "Get Started",
    secondaryButtonText: "Contact sales <br />"
};
